<template>
  <lazy-div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <quick-info-query @init="doInit"></quick-info-query>
        </v-flex>
        <v-flex xl6 xs12>
          <general></general>
        </v-flex>
        <v-flex xl6 xs12>
          <premium></premium>
        </v-flex>
        <v-flex xl6 xs12>
          <applicant></applicant>
        </v-flex>
        <v-flex xl6 xs12>
          <excess-stats></excess-stats>
        </v-flex>
        <v-flex xl6 xs12>
          <driver></driver>
        </v-flex>
        <v-flex xl6 xs12>
          <vehicle></vehicle>
        </v-flex>
        <v-flex xl6 xs12 v-if="commonForm.paytMode">
          <payment></payment>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <comments query></comments>
        </v-flex>
      </v-layout>
    </v-container>
  </lazy-div>
</template>

<script>
import { quoteStatus } from '@/const/underwriting'
import QuickInfoQuery from './QuickInfoQuery'
import General from './General'
import Vehicle from './Vehicle'
import Applicant from './Applicant'
import Driver from './Driver'
import ExcessStats from './ExcessStats'
import Premium from './Premium'
import Payment from './Payment'
import Comments from '../../shared/Comments'

export default {
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    currentStatus() {
      return quoteStatus[this.$store.state.agency.quotation.commonInfo.statusCode]
    }
  },
  methods: {
    async doInit() {
      try {
        const dispatchObj = {
          proposalNo: this.id,
          query: true
        }
        await this.$store.dispatch('loadQuote', dispatchObj)
      } catch (err) {
        throw err
      }
    }
  },
  props: [
    'id'
  ],
  components: {
    QuickInfoQuery,
    General,
    Vehicle,
    Applicant,
    Driver,
    ExcessStats,
    Premium,
    Payment,
    Comments
  }
}
</script>

<style>

</style>
